export default "__VITE_ASSET__PBFjn2TR__"